import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Nullable } from 'clickNgo/models/utils'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { RetailInfoEditMode } from './components/retailInfoEditMode/RetailInfoEditMode'
import { RetailInfoReadMode } from './components/retailInfoReadMode/RetailInfoReadMode'
import { TRANSLATION_KEYS } from './translations'

import styles from './RetailInfo.module.scss'

interface IRetailInfoProps {
  employersCount: Nullable<number>
  salesCount: Nullable<number>
}

export const RetailInfo: FC<IRetailInfoProps> = ({ employersCount, salesCount }) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && (
        <RetailInfoReadMode employersCount={employersCount} salesCount={salesCount} />
      )}
      {isEditMode && <RetailInfoEditMode employersCount={employersCount} salesCount={salesCount} />}
    </div>
  )
}
